<script lang="ts" setup>
import { useRedirect } from "@core/composables"
import { useSourceStore } from "@core/stores/source.store"
import { storeToRefs } from "pinia"
import { computed } from "vue"

// ================================
// TYPES & INTERFACES
// ================================

type Props = {
    /** Titre de la page. */
    title: string
    /** Identifiant de la source (_id_source) pour le breadcrumb. */
    sourceId: string
    /** Icône PrimeIcons pour le breadcrumb (ex: "pi pi-chart-line"). */
    icon?: string
    /** Classes CSS additionnelles pour l'élément header. */
    classHeader?: string
    /** Affiche le skeleton sur le breadcrumb (défaut: état du store isFetchingSourceById). */
    loading?: boolean
}

// ================================
// PROPS & EMITS
// ================================

const props = withDefaults(defineProps<Props>(), {
    icon: "",
    classHeader: "",
    loading: undefined,
})

// ================================
// COMPOSABLES
// ================================

const sourceStore = useSourceStore()
const { redirectWrapper } = useRedirect()

// ================================
// STATE
// ================================

const { isFetchingSourceById } = storeToRefs(sourceStore)

/** Skeleton breadcrumb : prop explicite ou chargement source depuis le store. */
const getLoading = computed(() =>
    props.loading !== undefined ? props.loading : isFetchingSourceById.value
)
</script>

<template>
    <div class="header-page-source flex flex-col gap-4">
        <BreadCrumbSource
            :source-id="sourceId"
            :loading="getLoading"
            :title="title"
            :icon="icon"
            :on-navigate="redirectWrapper"
        />
        <header :class="classHeader">
            <h1 class="text-2xl font-semibold text-blue-700">
                {{ title }}
            </h1>
            <slot />
        </header>
    </div>
</template>
